import React, { useState, useId } from "react";
import { Tooltip } from "reactstrap";
import { generateRandomString } from "../../helpers/string_helper";

const InformationToolTip = ({ informationText, placement = "top" }) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [targetId, setTargetId] = useState(generateRandomString(18));

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      <span className="ri-information-line cursor-pointer" id={targetId}></span>
      <Tooltip
        placement={placement}
        isOpen={tooltipOpen}
        autohide={false}
        target={targetId}
        toggle={toggle}
        style={{ textAlign: 'left', whiteSpace: 'pre-line' }} // Left align and handle spacing
      >
        {informationText}
      </Tooltip>
    </div>
  );
};

export default InformationToolTip;
